// test2472
(2472 && 0);
